<template>
    <div id="etiquette-dpe" v-if="this.post.dpe_etiquette_seuil">
        <el-row>
            <el-col :span="12">
                <div id="dpe">
                    <div id="valeur-dpe" :class="'valeur-'+ lowerStr(this.post.dpe_etiquette_conso)">
                        <div class="valeur-block">
                            {{ this.post.dpe_valeur_conso }}<br />
                            <span style="font-size: 8px;">kWh/m².an</span>
                        </div>
                        <div class="valeur-block">
                            {{ this.post.dpe_valeur_ges }}<br />
                            <span style="font-size: 8px;">kgCO2/m².an</span>
                        </div>
                    </div>
                    <img src="@/assets/vignette-dpe.jpg" alt="dpe" />
                </div>
            </el-col>
            <el-col :span="12">
                <div id="ges">
                    <div id="valeur-ges" :class="'valeur-'+ lowerStr(this.post.dpe_etiquette_ges)">
                        <div class="valeur-block">
                            {{ this.post.dpe_valeur_ges }}<br />
                            <span style="font-size: 8px;">kgCO2/m².an</span>
                        </div>
                    </div>
                    <img src="@/assets/vignette-ges.jpg" alt="ges" />
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  name: 'EtiquetteDPEGES',
  props: ['post'],
  data () {
    return {}
  },
  computed: {},
  methods: {
    lowerStr (str) {
      if (str != null) {
        return str.toLowerCase()
      }
    }
  }
}
</script>

<style type="text/css">
    #etiquette-dpe {
        width:500px;
        height:180px;
        position:relative;
    }

    #etiquette-dpe #dpe, #etiquette-dpe #ges {
        width:236px;
        height:180px;
        position:relative;
        float:left;
    }

    #etiquette-dpe #dpe {
        margin-right:15px;
    }

    #etiquette-dpe img {
        position:relative;
        z-index:998;
    }

    #etiquette-dpe #dpe #valeur-dpe, #etiquette-dpe #ges #valeur-ges {
        height:25px;
        position:absolute;
        right:120px;
        z-index:999;
        font:bold 12px Arial, Helvetica, sans-serif;
    }

    #etiquette-dpe .valeur-block {
        float: left;
        text-align: center;
        border: 1px solid;
        padding-left: 2px;
        padding-right: 2px;
    }

    #etiquette-dpe .valeur-a {
        top:8px;
    }
    #etiquette-dpe .valeur-b {
        top:36px;
    }
    #etiquette-dpe .valeur-c {
        top:64px;
    }
    #etiquette-dpe .valeur-d {
        top:93px;
    }
    #etiquette-dpe .valeur-e {
        top:122px;
    }
    #etiquette-dpe .valeur-f {
        top:148px;
    }
    #etiquette-dpe .valeur-g {
        top:177px;
    }
</style>
